import React, { FC, useContext } from 'react';

import { H3, Tooltip } from '@smartshell/ui-kit';
import cn from 'classnames';

import { LocalizationContext } from 'localization';
import { EPromoScopeType, EPromoValueType } from 'types';

import s from './FormComponents.module.scss';
import { IAreasActionProps } from './interfaces';

export const AreasAction: FC<IAreasActionProps> = ({
  areas,
  setAreas,
  rewardType,
}) => {
  const { t } = useContext(LocalizationContext);

  return (
    <div className={s.frame}>
      <div className={s.position_top}>
        <div className={s.header}>
          <div className={s.title_block}>
            <H3>{t('promo_group.areas')}</H3>

            {rewardType === 'DISCOUNT' && (
              <Tooltip
                contentClassName={s.tooltip}
                content={t('promo.client.areas.tooltip')}
              />
            )}
          </div>
          <span className={s.text}>{t('promo.client.areas.test')}</span>
        </div>
      </div>

      <div className={s.areas_block}>
        {areas.map((item) => (
          <div
            onClick={() => {
              if (
                item.value === EPromoScopeType.BILLING &&
                rewardType === EPromoValueType.DISCOUNT
              )
                return;
              setAreas((prev) =>
                prev.map((area) =>
                  area.value === item.value
                    ? { ...area, active: !area.active }
                    : area
                )
              );
            }}
            key={item.value}
            className={cn(
              s.item,
              item.active && s.active,
              item.disabled && s.disabled,
              item.value === EPromoScopeType.BILLING &&
                rewardType === EPromoValueType.DISCOUNT &&
                s.noClick
            )}
          >
            <span className={s.check_text}>{item.title}</span>
          </div>
        ))}
      </div>
      {!areas.some((item) => item.active) && rewardType && (
        <span className={s.info}>{t('promo.areas.notification')}</span>
      )}
    </div>
  );
};
